// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"125":"0dee0948","494":"877ea1a0","497":"d6bb0415","578":"c2ced32b","641":"2316ba08","705":"55b91b78","778":"7f462ad2","884":"ff07c842"}[chunkId] + ".chunk.js";
};